var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgArborMedia = function SvgArborMedia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200pt",
    height: "200pt",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0089ce",
    d: "M112.11 2.18L84.55 12.94l11.6 35.72 15.82-6.95.14-39.53zm41.8.53l-13.08 37.11 12.71 3.71 19.34-32.34-18.97-8.48zm39.24 32.39l-24.164 22.88 4.813 10.28L200 51.82l-6.85-16.72zm-153.18 10l-21 25.77L55.9 84.82l11.9-15.81L39.97 45.1zm159 37.92l-24.23 7.71-2.62 12.4 21.45-.46 5.4-19.65zm-72.81 23.9l-22.57 4.66-20.3 87.22 34.03-11.46 8.84-80.42zM0 115.9v28.08l42.53-13.59.45-14.26L0 115.9zm159.41 10.46l-8.52 11.49 12.28 11.17 13.62-16.41-17.38-6.25zM50.46 153.53l-34.2 22.71 15.67 11.62 26.88-25.82-8.35-8.51z"
  })));
};

;
export default SvgArborMedia;